class TimeSelectFormElementController {
  constructor() {

  }

  $onInit() {
    var self = this;
    self.options = [
      {
        label: '06:00',
        value: '06:00'
      },
      {
        label: '07:00',
        value: '07:00'
      },
      {
        label: '08:00',
        value: '08:00'
      },
      {
        label: '09:00',
        value: '09:00'
      },
      {
        label: '10:00',
        value: '10:00'
      },
      {
        label: '11:00',
        value: '11:00'
      }
    ];

    // TODO: set initial value

    // angular.forEach(self.options, function(option){
    //   if(parseInt(option.value) === parseInt(self.value)){
    //     self.item = option;
    //   }
    // });
  }

  $onChanges(changes) {
    // var self = this;
    // console.log(changes)
    // if(changes.value) {
    //   angular.forEach(self.options, function(option){
    //     if(option.value === self.value){
    //       self.item = option;
    //     }
    //   });
    // }
  }

  changed() {
    this.value = this.item.value;
  }
}

export default TimeSelectFormElementController;
